import { render, staticRenderFns } from "./IconSvgAPAUpdates.vue?vue&type=template&id=fbd7ef80&scoped=true&"
import script from "./IconSvgAPAUpdates.vue?vue&type=script&lang=js&"
export * from "./IconSvgAPAUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd7ef80",
  null
  
)

export default component.exports